import UiServiceImpl from "./UiServiceImpl";
import { BaseService } from "./Service";

export interface UiService extends BaseService {
	showLoading(): void;

	hideLoading(): void;

	showMessage( message: string ): void;

	showErrorMessage( message: string ): void;

	toDisplayDate( date: Date ): string;

	toDisplayCurrency( value: number, withAed: boolean ): string;

	toDisplayShortCurrency( value: number, withAed: boolean ): string;
}

const uiService = new UiServiceImpl();
export default uiService;
